// Reviews Pagination functionality
class ReviewsPaginationHandler {
  constructor() {
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.load-more-reviews-button');
      if (button) {
        event.preventDefault();
        this.handleLoadMoreReviews(button);
      }
    });
  }

  async handleLoadMoreReviews(button) {
    const reviewsGrid = button.closest('.product-reviews-section').querySelector('.reviews-grid');
    const paginationWrapper = button.closest('.reviews-pagination-wrapper');

    if (!reviewsGrid || !paginationWrapper) return;

    const currentPage = parseInt(paginationWrapper.dataset.currentPage) || 1;
    const totalPages = parseInt(paginationWrapper.dataset.totalPages) || 1;
    const reviewsPerPage = parseInt(button.dataset.reviewsPerPage) || 4;

    // Show loading state
    this.setLoadingState(button, true);

    try {
      // Simulate loading delay for better UX
      await new Promise((resolve) => setTimeout(resolve, 300));

      // Calculate which reviews to show
      const nextPage = currentPage + 1;
      const reviewsToShow = nextPage * reviewsPerPage;
      const startIndex = currentPage * reviewsPerPage;

      // Show additional reviews by removing the 'hidden' class
      const hiddenReviews = reviewsGrid.querySelectorAll('.review-item.hidden');
      let reviewsShown = 0;

      hiddenReviews.forEach((reviewItem, index) => {
        if (reviewsShown < reviewsPerPage) {
          reviewItem.classList.remove('hidden');
          reviewsShown++;
        }
      });

      // Update pagination state
      paginationWrapper.dataset.currentPage = nextPage;

      // Hide button if no more pages
      if (nextPage >= totalPages || reviewsShown === 0) {
        paginationWrapper.remove();
      } else {
        this.setLoadingState(button, false);
      }
    } catch (error) {
      console.error('Error loading more reviews:', error);
      this.setErrorState(button);
    }
  }

  setLoadingState(button, loading) {
    const text = button.querySelector('.load-more-text');
    const loadingText = button.querySelector('.load-more-loading');

    if (loading) {
      button.disabled = true;
      text.classList.add('hidden');
      loadingText.classList.remove('hidden');
    } else {
      button.disabled = false;
      text.classList.remove('hidden');
      loadingText.classList.add('hidden');
    }
  }

  setErrorState(button) {
    const text = button.querySelector('.load-more-text');
    const loadingText = button.querySelector('.load-more-loading');

    button.disabled = false;
    text.textContent = 'Try again';
    text.classList.remove('hidden');
    loadingText.classList.add('hidden');
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ReviewsPaginationHandler();
});
